import React, { ForwardRefExoticComponent, forwardRef } from 'react';
import { Slide, TransitionsOptions } from '@material-ui/core';

const Transition: ForwardRefExoticComponent<any> = forwardRef<unknown, TransitionsOptions>(
  function TransitionForwarded(props, ref) {
    // @ts-ignore-next-line
    return <Slide direction="up" ref={ref} {...props} />;
  }
);

export default Transition;
